import Kfit from '../integrations/Kfit';

export default params => Kfit.post(`/v8/statements/email_statements`, params);
